export const UPDATE_REGISTRATIONS = 'account/UPDATE_REGISTRATIONS'
